import {notification} from "antd";

export default function (text: string) {
    return notification["error"]({
        message: text,
        duration: 3.5,
    })
}
